import { useState } from "react";
import "./Signup.css";
//import { FcGoogle } from "react-icons/fc";
//import { FaApple } from "react-icons/fa";
import loginImg from "../assets/images/logo.svg";
import { Link } from "react-router-dom";


const Signup = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(form);
  };

  return (
    <div className="signup-wrapper">
      <div className="signup-card">
          <div className="logo">
        <div className="logo-circle">
          <img src={loginImg} alt="Login" className="login-image" />
        </div>
      </div>
        <h2>Create an account</h2>

        <p className="login-link">
          Already have an account? <Link to="/login">Login</Link>
        </p>

        <form onSubmit={handleSubmit}>
          <label>
            What should we call you <span>*</span>
          </label>
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={form.name}
            onChange={handleChange}
            required
          />

          <label>
            What is your email <span>*</span>
          </label>
          <input
            type="email"
            name="email"
            placeholder="you@example.com"
            value={form.email}
            onChange={handleChange}
            required
          />

          <label>
            Create a password <span>*</span>
          </label>
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={form.password}
            onChange={handleChange}
            required
          />

          <p className="terms-text">
            By creating an account, you agree to the{" "}
            <Link to="/terms">Terms of use</Link> &{" "}
            <Link to="/privacy">Privacy policy</Link>
          </p>

          <button type="submit" className="signup-btn">
            Create an account
          </button>
        </form>

        {/* <div className="divider">
          <span>Or continue with</span>
        </div> */}

        {/* <div className="social-row">
          <button className="social-btn google">
            <FcGoogle size={20} />
            Continue with Google
          </button>

          <button className="social-btn apple">
            <FaApple size={20} />
            Continue with Apple
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default Signup;
